module.exports = __webpack_public_path__ + "static/person-65751e6b6f8a60cf73f3b2684d2fa29f.jpeg";